<template>
    <div class="card mt-3 mb-4">
      <div class="card-body">
        <div class="text-center mb-4">
          <h1 class="display-4 text-primary fw-bold border-bottom pb-3 border-3 border-primary">
            TURNOS DE ATENCIÓN
          </h1>
        </div>
  
        <div class="turns-list">
          <div
            v-for="(turno, index) in turnosOrdenados"
            :key="index"
            class="turn-card mb-4 rounded-4"
            :class="{
              'current-turn': index === 0,
              'attended-turn': turno.atendido,
              'unique-specialty-turn': esUnicoPorEspecialidadYDoctor(turno)
            }"
            :style="getTurnStyle(turno, index)"
          >
            <div class="row align-items-center">
              <div class="col-2 text-center">
                <div class="fs-1 fw-bold" :style="getTextStyle(turno, index)">
                  {{ turno.numero }}
                </div>
              </div>
              <div class="col-5">
                <div class="fs-3 fw-semibold mb-2" :style="getTextStyle(turno, index)">
                  {{ turno.paciente }}
                </div>
                <div class="fs-4 fw-medium" :style="getTextStyle(turno, index)">
                  DR. {{ turno.doctor }}
                </div>
              </div>
              <div class="col-5 text-end">
                <div class="fs-3 fw-semibold mb-1 especialidad-texto" :style="getTextStyle(turno, index)">
                  {{ turno.especialidad }}
                </div>
                <div class="fs-5" :style="getTextStyle(turno, index)">
                  {{ turno.fecha }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  


<script>
/* eslint-disable */


export default {
    name: "Presentar-en-Tv",
    components: {

    },

    data() {
        return {
            loading: true,
            isMobile: this.$isMobile,
            tokenAuth: localStorage.getItem("tokenAuth"),
            nextTurns: [],
            refreshInterval: null,
            audioPlayer: null // Inicializamos como null para configurarlo después
        };
    },
    computed: {
        turnosOrdenados() {
            return [...this.nextTurns].sort((a, b) => {
                // Primero los no atendidos
                if (!a.atendido && b.atendido) return -1;
                if (a.atendido && !b.atendido) return 1;

                // Luego los turnos marcados (próximos a atender)
                const aEsProximo = this.esUnicoPorEspecialidadYDoctor(a); // Cambiado aquí
                const bEsProximo = this.esUnicoPorEspecialidadYDoctor(b); // Cambiado aquí

                if (aEsProximo && !bEsProximo) return -1;
                if (!aEsProximo && bEsProximo) return 1;

                // Si ambos son marcados o no marcados, ordenar por fecha
                if (aEsProximo === bEsProximo) {
                    return new Date(a.fecha) - new Date(b.fecha);
                }

                return 0;
            });
        }
    },
    watch: {},

    activated() {
        this.handleNewUpdateTv()
    },

    beforeUnmount() {
        clearInterval(this.intervalo);

        if (this.refreshInterval) {
            clearInterval(this.refreshInterval);
        }

        if (this.audioPlayer) {
            this.audioPlayer.pause();
            this.audioPlayer.src = '';
            this.audioPlayer = null;
        }

        // Remover el listener del evento
        this.$eventBus.off('new_insert', this.handleNewUpdateTv);
        this.$eventBus.off('emitirAlerta', this.handleEmitirAlerta);


    },
    mounted() {



        const minutos = 1;
        const milisegundos = minutos * 60 * 1000;

        setInterval(() => {
            this.cargaDatosPacienteTv();
        }, milisegundos);

        // Inicializamos el reproductor de audio cuando el componente se monta
        this.audioPlayer = new Audio('/sounds/turn-sound.mp3');
        this.audioPlayer.preload = 'auto';        

        this.audioPlayer.addEventListener('canplaythrough', () => {
            //console.log('El archivo de audio está listo para ser reproducido.');
        });

        if (this.isMobile) {
            this.$eventBus.emit("activeShowMenu");
        }


        // Escuchar el evento global 'new_insert'
        this.$eventBus.on('new_insert', this.handleNewUpdateTv);

        this.$eventBus.on('emitirAlerta', this.handleEmitirAlerta);

        

    },
    methods: {

      speakName(name) {
        const utterance = new SpeechSynthesisUtterance(name);
        utterance.lang = 'es-ES'; // o 'en-US', depende del idioma que prefieras
        utterance.rate = 1;       // velocidad de lectura (0.1 a 10)
        utterance.pitch = 1;      // tono (0 a 2)
        window.speechSynthesis.speak(utterance);
      },

        handleNewUpdateTv() {
            this.cargaDatosPacienteTv(); // Recargar los datos

        },

        handleEmitirAlerta(data) {
            const medico = data && data.medico ? data.medico : 'médico'
            this.showSuccessToast('Alerta recibida de ' + medico)
            this.reproducirAudio()
        },

        reproducirAudio() {
            //console.log('Reproducir audio')
            this.audioPlayer.currentTime = 0; // Reiniciar el audio al inicio
            return this.audioPlayer.play().catch(error => {
                console.error('Error al reproducir el sonido:', error);
            });
        },

        cargaDatosPacienteTv() {
            // Guardar los turnos activos actuales antes de la actualización
            const turnosActivosAnteriores = this.nextTurns
                .filter(t => !t.atendido && this.esUnicoPorEspecialidadYDoctor(t))
                .map(t => t.cod_paciente);

            this.$https.post('/listar/getListarPacientesTv', {}, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.tokenAuth,
                }
            }).then(async response => {
                if (response.data.code === 200) {

                    this.showSuccessToast('Verificando...')


                    // Agrupar por especialidad y doctor, y ordenar por fecha
                    const turnosPorEspecialidadYDoctor = {};
                    response.data.datos.forEach(turno => {
                        const key = `${turno.name_especialidad}-${turno.doctor}`;
                        if (!turnosPorEspecialidadYDoctor[key]) {
                            turnosPorEspecialidadYDoctor[key] = [];
                        }
                        turnosPorEspecialidadYDoctor[key].push(turno);
                    });

                    // Procesar cada especialidad y doctor y asignar números
                    const turnosProcessed = [];
                    Object.keys(turnosPorEspecialidadYDoctor).forEach(key => {
                        // Ordenar turnos de esta especialidad y doctor por fecha
                        const turnosOrdenados = turnosPorEspecialidadYDoctor[key].sort(
                            (a, b) => new Date(a.date_at) - new Date(b.date_at)
                        );

                        // Asignar números consecutivos dentro de cada especialidad y doctor
                        turnosOrdenados.forEach((turno, index) => {
                            turnosProcessed.push({
                                numero: `A${String(index + 1).padStart(3, '0')}`,
                                paciente: turno.nombres_pacientes,
                                especialidad: turno.name_especialidad,
                                doctor: turno.doctor,
                                fecha: turno.date_at,
                                atendido: turno.estado === 'Atendido',
                                cod_paciente: turno.cod_paciente
                            });
                        });
                    });

                    this.nextTurns = turnosProcessed;

                    // Verificar si hay nuevos turnos activos después de actualizar
                    const nuevosTurnosActivos = turnosProcessed
                        .filter(t => !t.atendido && this.esUnicoPorEspecialidadYDoctor(t));

                    // Reproducir el sonido solo si hay nuevos turnos activos
                    const hayNuevosTurnos = nuevosTurnosActivos.some(
                        turno => !turnosActivosAnteriores.includes(turno.cod_paciente)
                    );

                    //console.log('Hay nuevos turnos')

                    if (hayNuevosTurnos) {
                        //console.log('Sii')
                        
                        // Encontrar el nuevo turno activo
                        const nuevoTurno = nuevosTurnosActivos.find(
                            turno => !turnosActivosAnteriores.includes(turno.cod_paciente)
                        );
                        
                        if (nuevoTurno) {
                            console.log('Nuevo turno activo:', nuevoTurno.paciente);
                            console.log('Especialidad:', nuevoTurno.especialidad);
                            console.log('Doctor:', nuevoTurno.doctor);
                            console.log('Número de turno:', nuevoTurno.numero);
                        }
                        
                        // Primero reproducir el audio
                        this.reproducirAudio();
                        
                        // Esperar a que termine el audio y luego hablar
                        /* setTimeout(() => {
                            this.speakName(nuevoTurno.paciente + ' Especialidad ' + nuevoTurno.especialidad);
                        }, 2000); // 2 segundos de espera */
                        
                    }
                }
            }).catch(error => {
                console.error('Error al cargar los turnos:', error);
            });
        },

        esUnicoPorEspecialidadYDoctor(turno) {
            const turnosMismaEspecialidadYDoctor = this.nextTurns.filter(t =>
                t.especialidad === turno.especialidad &&
                t.doctor === turno.doctor &&
                !t.atendido
            );

            if (turnosMismaEspecialidadYDoctor.length === 1) {
                return true;
            }

            // Si hay más de un turno de la misma especialidad y doctor, verificar si este es el más próximo
            if (turnosMismaEspecialidadYDoctor.length > 1) {
                const fechasOrdenadas = [...turnosMismaEspecialidadYDoctor].sort((a, b) =>
                    new Date(a.fecha) - new Date(b.fecha)
                );
                // El primer turno (más antiguo) de cada especialidad y doctor debe ser el siguiente
                return fechasOrdenadas[0].cod_paciente === turno.cod_paciente;
            }
            return false;
        },

        getTurnStyle(turno, index) {
            if (turno.atendido) {
                return 'background-color: white; border: 2px solid #e9ecef; border-radius: 10px;';
            }
            if (this.esUnicoPorEspecialidadYDoctor(turno)) {
                return 'background-color: #0078be; color: white; border-radius: 15px;';
            }
            return 'background-color: #f8f9fa; border-radius: 10px; border-left: 5px solid #0078be;';
        },

        getTextStyle(turno, index) {
            if (turno.atendido) {
                return 'color: #6c757d;';
            }
            if (this.esUnicoPorEspecialidadYDoctor(turno)) {
                return 'color: white;';
            }
            return 'color: #0078be;';
        },

    }

}



</script>


<style scoped>

/* Estilo general para cada tarjeta de turno */
.turn-card {
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  border: none;
  border-radius: 1.5rem; /* Más redondeado para pantallas grandes */
}

.turn-card:hover {
  transform: scale(1.01);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
}

/* Estilo para el turno actual o siguiente por especialidad */
.current-turn,
.unique-specialty-turn {
  background-color: #0078be !important;
  color: white !important;
  box-shadow: 0 8px 20px rgba(0, 120, 190, 0.3);
}

/* Estilo para turnos ya atendidos */
.attended-turn {
  opacity: 0.5;
  background-color: #ffffff !important;
  color: #6c757d !important;
  box-shadow: none;
}

/* Ajuste del contenedor de lista */
.turns-list {
  margin-top: 2rem;
}

/* Estilo del título principal */
h1.display-4 {
  font-weight: 700;
  font-size: 3.5rem;
  color: #eb1265!important;
}

/* Estilo de los textos principales de las tarjetas */
.fs-1 {
  font-size: 3.5rem !important; /* Número de turno */
}

.fs-3 {
  font-size: 2.2rem !important; /* Nombre del paciente */
  font-weight: bold;
}

.fs-4 {
  font-size: 1.6rem !important; /* Nombre del doctor */
}

.especialidad-texto {
  font-size: 1.5rem!important; /* o el tamaño que desees */
  font-weight: 600;
}

.fs-5 {
  font-size: 1.5rem !important; /* Fecha */
}




</style>